import { useState } from 'react'

import { Button, Grid } from '@mui/material'

import { PobDetails } from '../PobDetails'
import { PodDetails } from '../PodDetails'

interface IProps {
  hoverText: string
  disabled: boolean
  isPobPodButtonsDisabled?: boolean
  bookingId?: string
}

const PobPodButtons = (props: IProps) => {
  const { hoverText, disabled, isPobPodButtonsDisabled, bookingId } = props
  const [openPobDetailsDialog, setOpenPobDetailsDialog] = useState<boolean>(false)
  const [openPodDetailsDialog, setPodDetailsDialog] = useState<boolean>(false)


  const handleViewPob = () => setOpenPobDetailsDialog(true)

  const handleViewPod = () => setPodDetailsDialog(true)

  const handleClosePobDetailsDialog = () => setOpenPobDetailsDialog(false)

  const handleClosePodDialog = () => setPodDetailsDialog(false)

  return (
    <>
      <Grid container spacing={1.5}>
        <Grid item>
          <Button
            variant='contained'
            color='grey'
            disabled={isPobPodButtonsDisabled}
            onClick={handleViewPob}>
            View POB
          </Button>
        </Grid>

        <Grid item>
          <Button
            variant='contained'
            color='grey'
            disabled={isPobPodButtonsDisabled}
            onClick={handleViewPod}>
            View POD
          </Button>
        </Grid>
      </Grid>

      {openPobDetailsDialog && bookingId && (
        <PobDetails
          bookingId={bookingId}
          openDialog={openPobDetailsDialog}
          hoverText={hoverText}
          disabled={disabled}
          handleCloseDialog={handleClosePobDetailsDialog}
        />
      )}

      {openPodDetailsDialog && bookingId && (
        <PodDetails
          bookingId={bookingId}
          openDialog={openPodDetailsDialog}
          hoverText={hoverText}
          disabled={disabled}
          handleCloseDialog={handleClosePodDialog}
        />
      )}
    </>
  )
}

export default PobPodButtons
